import { MapPin, Clock, MessageCircle, Navigation } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";
import { openWhatsApp } from "@/lib/api";

export default function Footer() {
  return (
    <footer id="visit" className="bg-[#0C0A09] border-t border-[#292524]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-24 sm:py-32">
        <div className="grid md:grid-cols-12 gap-14">
          <Reveal className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#C4A47C]" />
              <span className="label text-[#C4A47C]">Visit / Order</span>
            </div>
            <h2 className="font-serif font-light text-4xl sm:text-6xl tracking-tighter text-[#F5F5F0] leading-[1.02]">
              Come say hello, or order in a tap.
            </h2>
            <p className="mt-6 text-[#A8A29E] font-light max-w-md leading-relaxed">
              We hand-pour to order. Message us on WhatsApp for availability, custom fragrances,
              bulk gifting and event orders.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <button
                onClick={() => openWhatsApp("Hi Ave_luxe_candles! I'd like to place an order.")}
                className="inline-flex items-center gap-2 rounded-full bg-[#C4A47C] hover:bg-[#D8BC97] text-[#0C0A09] px-7 py-4 text-sm font-medium transition-colors"
                data-testid="footer-whatsapp-btn"
              >
                <MessageCircle size={16} strokeWidth={1.5} /> Order on WhatsApp
              </button>
              <a
                href="https://www.google.com/maps/search/?api=1&query=Ave_luxe_candles+Mourigram+Howrah"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-[#292524] hover:border-[#C4A47C] text-[#F5F5F0] px-7 py-4 text-sm font-medium transition-colors"
                data-testid="footer-directions-btn"
              >
                <Navigation size={16} strokeWidth={1.5} /> Get directions
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="md:col-span-5">
            <div className="space-y-8 border-l border-[#292524] pl-8">
              <div className="flex gap-4">
                <MapPin size={20} strokeWidth={1.3} className="text-[#C4A47C] shrink-0 mt-1" />
                <div>
                  <p className="label mb-1">Address</p>
                  <p className="text-[#F5F5F0] font-light">Mourigram, Howrah, West Bengal 711109</p>
                </div>
              </div>
              <div className="flex gap-4">
                <Clock size={20} strokeWidth={1.3} className="text-[#C4A47C] shrink-0 mt-1" />
                <div>
                  <p className="label mb-1">Hours</p>
                  <p className="text-[#F5F5F0] font-light">Open daily · Closes 5 PM</p>
                </div>
              </div>
              <div className="flex gap-4">
                <MessageCircle size={20} strokeWidth={1.3} className="text-[#C4A47C] shrink-0 mt-1" />
                <div>
                  <p className="label mb-1">Follow</p>
                  <p className="text-[#F5F5F0] font-light">Ave_luxe_candles on Google · 5.0 ★</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="mt-20 pt-8 border-t border-[#292524] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-serif text-2xl text-[#F5F5F0]">
            Ave<span className="text-[#C4A47C]">.</span>luxe candles
          </p>
          <div className="flex items-center gap-6">
            <span className="label">© {new Date().getFullYear()} · Handmade in Howrah</span>
            <Link to="/login" className="label link-underline text-[#A8A29E]" data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
